require('../fhApp/currentUser/currentUser');
require('./gamesOfTheWeekService');

angular.module('app.gamesOfTheWeek.gamesOfTheWeekController', [
  'app.currentUser',
  'app.gamesOfTheWeek.gamesOfTheWeekService'
])
  .controller('app.gamesOfTheWeek.gamesOfTheWeekController', [
    '$scope',
    'currentUser',
    'app.gamesOfTheWeek.gamesOfTheWeekService',
    function ($scope, currentUser, gotw) {
      "use strict";

      $scope.currentUser = currentUser;
      $scope.gotw = gotw;

      let init = function () {
        gotw.retrieve();
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/gamesOfTheWeek/gamesOfTheWeekController.js